import { create } from 'zustand';
const usePluginOutput = create(() => ({
    activeBroadcast: undefined,
}));
const reactiveOutput = {
    useActiveBroadcast: () => {
        return usePluginOutput((state) => state.activeBroadcast);
    },
    useRequiredActiveBroadcast: () => {
        const broadcast = reactiveOutput.useActiveBroadcast();
        if (broadcast === undefined) {
            throw new Error('Invalid context: no active broadcast');
        }
        return broadcast;
    },
};
export class BroadcastStateServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setActiveBroadcast(activeBroadcast) {
        usePluginOutput.setState({ activeBroadcast });
    }
}
